/*首页*/
// const home = resolve => require(['./page/home.vue'], resolve);
import home from '@/page/home'
// const home = resolve => require(['./page/home.vue'], resolve);
/*项目概要*/
const projectSummary = resolve => require(['./page/projectSummary/projectSummary.vue'],resolve);
/*项目管理*/
const projectManagement = resolve => require(['./page/projectManagement/projectManagement.vue'],resolve);
/*GIS地图*/
const GISMap = resolve => require(['./page/GISMap/GISMap.vue'],resolve);
/*用户管理*/
const userManagement = resolve => require(['./page/userManagement/userManagement.vue'],resolve);
/*历史数据*/
const historicalData = resolve => require(['./page/historicalData/historicalData.vue'],resolve);
/*告警维修*/
const alarmMaintenance = resolve => require(['./page/alarmMaintenance/alarmMaintenance.vue'],resolve);
const repairPersonnel = resolve => require(['./page/alarmMaintenance/repairPersonnel.vue'],resolve);
const maintenanceRecord = resolve => require(['./page/alarmMaintenance/maintenanceRecord.vue'],resolve);
const streetLightInformation = resolve => require(['./page/alarmMaintenance/streetLightInformation.vue'],resolve);
/*分组与策略*/
const grouping = resolve => require(['./page/groupingStrategy/grouping.vue'],resolve);
const addGrouping = resolve => require(['./page/groupingStrategy/addGrouping.vue'],resolve);
const strategy = resolve => require(['./page/groupingStrategy/strategy.vue'],resolve);
/*操作日志*/
const operationLog = resolve => require(['./page/operationLog/operationLog.vue'],resolve);
/*视频监控*/
const videoSurveillance = resolve => require(['./page/videoSurveillance/videoSurveillance.vue'],resolve);
const monitoringDetails = resolve => require(['./page/videoSurveillance/monitoringDetails.vue'],resolve);
/*环境监控*/
const weatherMonitor = resolve => require(['./page/weatherMonitor/weatherMonitor.vue'],resolve);
const monitorDetails = resolve => require(['./page/weatherMonitor/monitorDetails.vue'],resolve);
const monitoringContrast = resolve => require(['./page/weatherMonitor/monitoringContrast.vue'],resolve);
const routers = [
	{path:'/' , component:home},
	{path:'/home',component:home},
	{path:'/projectSummary',component:projectSummary},
	{path:'/projectManagement',component:projectManagement},
	{path:'/GISMap',component:GISMap},
	{path:'/userManagement',component:userManagement},
	{path:'/historicalData',component:historicalData},
	{path:'/alarmMaintenance',component:alarmMaintenance},
	{path:'/repairPersonnel',component:repairPersonnel},
	{path:'/maintenanceRecord',component:maintenanceRecord},
	{path:'/streetLightInformation',component:streetLightInformation},
	{path:'/grouping',component:grouping},
	{path:'/addGrouping',component:addGrouping},
	{path:'/strategy',component:strategy},
	{path:'/operationLog',component:operationLog},
	{path:'/videoSurveillance',component:videoSurveillance},
	{path:'/monitoringDetails',component:monitoringDetails},
	{path:'/weatherMonitor',component:weatherMonitor},
	{path:'/monitorDetails',component:monitorDetails},
	{path:'/monitoringContrast',component:monitoringContrast},
];

export default routers;


// WEBPACK FOOTER //
// ./src/router.js